/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locales_It_ItInputs */

const en_us2_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const pt_br2_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const es_419_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const pt_pt2_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const fr_fr2_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const de_de2_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const it_it2_locales_it_it = /** @type {(inputs: Locales_It_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

/**
* | output |
* | --- |
* | "Italiano" |
*
* @param {Locales_It_ItInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const locales_it_it = /** @type {((inputs?: Locales_It_ItInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locales_It_ItInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_locales_it_it(inputs)
	if (locale === "es-419") return es_419_locales_it_it(inputs)
	if (locale === "pt-PT") return pt_pt2_locales_it_it(inputs)
	if (locale === "fr-FR") return fr_fr2_locales_it_it(inputs)
	if (locale === "de-DE") return de_de2_locales_it_it(inputs)
	if (locale === "it-IT") return it_it2_locales_it_it(inputs)
	return en_us2_locales_it_it(inputs)
});
export { locales_it_it as "locales.it_it" }